import { Injectable } from '@angular/core';
import { DataService } from './data.service';

@Injectable()
export class ProfileListService {
    getEventRoute = '/api/lookup/';

    constructor(private dataService: DataService) {
    };
//supliercargo list
getCargoListSpp( refresh: boolean) {
    return this.dataService.getRecord('/api/lookup/cargo/list')
}
//customercargo list
getCargoList( refresh: boolean) {
    return this.dataService.getRecord('/api/lookup/customerpl/list/')
}
getMessersLists(page :any,refresh:boolean){
    return this.dataService.getRecord('/api/lookup/messrs/list/'+page )
}
getEditcheck(id){
    return this.dataService.getRecord('/api/lookup/cargo/master/'+id)
}
downloadAttachment(id){
    return this.dataService.getRecord('/api/lookup/supplier/cargodetails/attachment/'+id)
}

login(data: any) {
    return this.dataService.post('/api/user/token/', data).map(response => {
        this.dataService.clearRouteCache(this.getEventRoute);
        return response;
    });
}
getCustomerList( refresh: boolean) {
    return this.dataService.getRecord('/api/lookup/customerdetails/list')
}

getEditcheckCustomer(id){
    return this.dataService.getRecord('/api/lookup/customerdetails/master/'+id)
}
downloadCustomerAttachment(id){
    return this.dataService.getRecord('/api/lookup/customer/cargodetails/attachment/'+id)
}

// deleteCustomerDetatils(id){
//     return this.dataService.delete('/api/customer/customer/delete/'+id)
// }
delete(Part_ID: number) {
    return this.dataService.delete('/api/customer/customer/delete/'+ Part_ID).map(response => {
        this.dataService.clearCache();
        this.dataService.clearRouteCache(this.getEventRoute);
        return response;
    });
}


}